import React from 'react';
import getEnvironDomain from 'utils/getEnvironDomain';
import Shape from 'ati-ui-react/components/Shape';
import Button from 'ati-ui-react/components/Button';
import { addMetric } from 'utils/addMetrics';
// eslint-disable-next-line import/no-extraneous-dependencies
import Icon from '@components/icon';
import Tooltip from 'ati-ui-react/components/Tip/Tooltip';
import Phone from '../Phone';
import {
  ContactStyles,
  ContactsContainer,
  Avatar,
  Info,
  InfoAndButtonWrapper,
  NameWrapper,
  Name,
  Status,
  ButtonContainer,
  Confirmed,
  ConfirmedWrapper,
} from './ContactStyles';

function Contact({ mt, contact, status, idFirm, contactId, fullContactId, isConfirmed }) {
  const isOnline = status === 'online';
  const domain = `//chat.${getEnvironDomain()}`;
  return (
    <ContactStyles mt={mt}>
      <Shape shadow>
        <ContactsContainer>
          <Avatar
            status={isOnline}
            src={`//api.${getEnvironDomain()}/v2/avatars/${idFirm}/contacts/${contactId}/60`}
          />
          <InfoAndButtonWrapper>
            <Info>
              <NameWrapper>
                <Name>{contact.name.trim()}</Name>
                <Status status={isOnline}>{isOnline ? 'онлайн' : 'не в сети'}</Status>
              </NameWrapper>
              {isConfirmed && (
                <ConfirmedWrapper>
                  <Tooltip
                    content="Контакт принадлежит реальному человеку"
                    place="top"
                    maxWidth={260}
                  >
                    <Confirmed>
                      <Icon name="ic_verification" />
                      <span>Контакт подтверждён</span>
                    </Confirmed>
                  </Tooltip>
                </ConfirmedWrapper>
              )}
              <Phone mt={12} contact={contact} wrap />
            </Info>
            <ButtonContainer onClick={() => addMetric('tm-click-msgr')}>
              <Button
                href={`${domain}/dialogs/${fullContactId}`}
                size="small"
                target="_blank"
                className="write-button"
              >
                Написать
              </Button>
            </ButtonContainer>
          </InfoAndButtonWrapper>
        </ContactsContainer>
      </Shape>
    </ContactStyles>
  );
}

export default Contact;
